import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICerere, IInchidereLucrare } from '../../cereri.interface';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { CereriService } from '../../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-modal-inchidere-lucrare',
    templateUrl: './modal-inchidere-lucrare.component.html',
    styleUrls: ['./modal-inchidere-lucrare.component.scss']
})
export class ModalInchidereLucrareComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    token!: string;
    isLoading: boolean = false;
    helper = helper;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    tipuriRezolutii: { name: string; id: string }[] = [
        {
            name: '--Alegeți--',
            id: '-1',
        },
        {
            id: '1',
            name: 'favorabil',
        },
        {
            id: '2',
            name: 'nefavorabil',
        },
        {
            id: '3',
            name: 'invalid',
        },
        // {
        //     id: '4',
        //     name: 'trimis',
        // },
    ];

    form: FormGroup = new FormGroup({
        finalizare_type: new FormControl('-1', [Validators.required, Validators.min(1)]),
        observatii: new FormControl(''),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ICerere,
        private dialogRef: MatDialogRef<ModalInchidereLucrareComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
    ) { }

    closeDialog(): void {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { finalizare_type, observatii } = this.form.value as IInchidereLucrare;

        const finalizareCerereData = {
            finalizare_type: Number(finalizare_type),
            observatii
        };

        this.cereriService
            .finalizareCerere(this.data.id_cerere, finalizareCerereData)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }
}
